import type { CommentSummaryResponse } from './commentSummaryTypes';

export const mapCommentSummaryResponseToMarkdown = (
	responseContent: CommentSummaryResponse,
): string => {
	if (!responseContent.summary || !responseContent.summary.thematic_summaries) {
		return '';
	}

	const { thematic_summaries } = responseContent.summary;

	// If no thematic summaries, return empty
	if (thematic_summaries.length === 0) {
		return '';
	}

	// thematic summaries
	return thematic_summaries
		.map((themeItem) => {
			if (!themeItem.theme || !themeItem.points || themeItem.points.length === 0) {
				return '';
			}

			// theme headings
			// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- no color values used
			const heading = `<h3 style="font-size: 16px; font-weight: 600; line-height: 20px; margin-top: 12px; margin-bottom: 8px; text-align: left;">${themeItem.theme}</h3>`;

			// theme points
			const points = themeItem.points
				.map((point) => {
					if (!point.text) {
						return '';
					}

					let pointContent = point.text;

					// if comments array is provided, append the links
					if (point.comments && point.comments.length > 0) {
						const links = point.comments.filter(Boolean).join(' ');
						if (links) {
							pointContent += ` ${links}`;
						}
					}

					return `* ${pointContent}`;
				})
				.filter(Boolean)
				.join('\n');

			// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- no color values used
			return points ? `${heading}\n${points}\n` : '';
		})
		.filter(Boolean)
		.join('\n');
};
